module.exports = __webpack_public_path__ + "img/PWA.5e727a6a.png";